import script from "./BaseAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&setup=true&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=2710c784&lang=scss"

const __exports__ = script;

export default __exports__